
export const dealerRegistration = {
  hero: {
    badge: 'BECOME A PARTNER',
    title: 'Become an Official Dutch Fires Dealer',
    subtitle: 'Join our exclusive network of professional partners and benefit from premium products, attractive margins, and full support.'
  },
  benefits: {
    title: 'Why Partner with Dutch Fires?',
    benefit1: {
      icon: 'ri-price-tag-3-line',
      title: 'Attractive Wholesale Prices',
      description: 'Benefit from competitive prices and high margins for your business'
    },
    benefit2: {
      icon: 'ri-shield-check-line',
      title: 'Exclusive Territory Rights',
      description: 'Secure your territory and minimize competition'
    },
    benefit3: {
      icon: 'ri-customer-service-2-line',
      title: 'Full Support',
      description: 'Marketing, technical training, and personal guidance'
    },
    benefit4: {
      icon: 'ri-truck-line',
      title: 'Flexible Delivery',
      description: 'Dropshipping, inventory, or project delivery of your choice'
    }
  },
  requirements: {
    title: 'Requirements for Dealership',
    subtitle: 'To become an official Dutch Fires dealer, we require:',
    req1: 'Registered business (Chamber of Commerce or equivalent)',
    req2: 'Active in fireplace, interior, or construction sector',
    req3: 'Professional showroom or online presence',
    req4: 'Commitment to quality and customer service'
  },
  form: {
    title: 'Registration Form',
    subtitle: 'Fill out the form below and we will contact you within 1-2 business days.',
    companyName: 'Company Name',
    companyNamePlaceholder: 'Your company name',
    contactPerson: 'Contact Person',
    contactPersonPlaceholder: 'First and last name',
    email: 'Email Address',
    emailPlaceholder: 'your.email@company.com',
    phone: 'Phone Number',
    phonePlaceholder: '+44 20 1234 5678',
    website: 'Website',
    websitePlaceholder: 'www.yourcompany.com',
    country: 'Country',
    countryPlaceholder: 'Select your country',
    industry: 'Industry',
    industryPlaceholder: 'Select your industry',
    message: 'Message',
    messagePlaceholder: 'Tell us about your business and why you want to become a Dutch Fires dealer...',
    submit: 'Submit Application',
    submitting: 'Submitting...',
    success: 'Thank you for your application! We will contact you within 1-2 business days.',
    error: 'Something went wrong. Please try again or contact us directly.',
    required: 'This field is required',
    invalidEmail: 'Invalid email address',
    industries: {
      fireplace: 'Fireplace Store',
      interior: 'Interior Store',
      construction: 'Construction Company',
      ecommerce: 'E-commerce',
      other: 'Other'
    }
  },
  process: {
    title: 'What Happens After Your Application?',
    step1: {
      title: 'Verification',
      description: 'We review your business information and assess your application'
    },
    step2: {
      title: 'Personal Contact',
      description: 'One of our account managers will contact you'
    },
    step3: {
      title: 'Onboarding',
      description: 'Access to dealer portal, training, and marketing materials'
    },
    step4: {
      title: 'Start Selling',
      description: 'Begin selling and benefit from our support'
    }
  },
  cta: {
    title: 'Questions? Contact Us Directly',
    email: 'info@dutchfires.de'
  }
};
